import { Button} from "antd";
import NoData from "assets/svgs/no_data/NoData";
import React, { useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import EditModal from "./EditModal";
import { fourPlaceHolder } from "modules/utilities/utility";

function SettingTable({ settingData, isLoading }) {
  const [settingKey, setSettingKey] = useState("");
  const [modalShow, setModalShow] = useState("");

  const handleEdit = (setting) => {
    setModalShow(true);
    setSettingKey(setting);
  };

  const header = ["Key", "Value", "Action"];

  return (
    <div>
      <div
        className="mt-1 shadow rounded mt-2 scrollable-container"
        style={{ maxHeight: "70vh", overflowY: "scroll" }}
      >
        <div
          className="d-flex table-head rounded-top"
          style={{ position: "sticky", top: "0", zIndex: "1" }}
        >
          {header?.map((setting) => {
            return (
              <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
                {setting}
              </span>
            );
          })}
        </div>
        {isLoading ? (
          fourPlaceHolder()
        ) : settingData && settingData?.length ? (
          settingData?.map((setting, index) => {
            return (
              <div
                className={`d-flex table-row border-1 border-top-0 ${
                  index === settingData?.length - 1 && `rounded-bottom`
                }`}
                key={setting?.key}
              >
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {setting?.key}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {setting?.value}
                </span>
                <span className="p-3 d-flex gap-4 flex-1 text-break text-black text-wrap  border-end">
                  <Button
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(setting)}
                    type="link"
                    primary
                  />
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            No Data Available <NoData />
          </div>
        )}
      </div>
      <EditModal
        modalShow={modalShow}
        setModalShow={setModalShow}
        settingKey={settingKey}
      />
    </div>
  );
}

export default SettingTable;
